import { KeyboardEvent, useEffect, useState } from 'react';

import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { Button } from '../../Button/Button';
import { Input } from '../../Input/Input';
import { Text } from '../../Text/Text';
import { FilterPill, FilterPillProps } from '../FilterPill/FilterPill';

interface FilterTextProps extends Pick<FilterPillProps, 'label'> {
    filterByLabel?: string;
    value?: string;
    onChange?: (value?: string) => void;
}

export const FilterText = (props: FilterTextProps) => {
    const [inputValue, setInputValue] = useState<string | undefined>(props.value);

    useEffect(() => {
        setInputValue(props.value);
    }, [props.value]);

    const handleKeyDown = (closePopover: () => void) => (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            closePopover();
            props.onChange?.(inputValue);
        }
    };

    return (
        <FilterPill
            label={props.label}
            value={inputValue}
            onClear={() => {
                setInputValue(undefined);
                props.onChange?.(undefined);
            }}
            onPopoverClose={() => {
                setInputValue(props.value);
            }}
        >
            {(closePopover) => (
                <Box padding="12px" display="flex" flexDirection="column" gap={16}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" gap={16}>
                        <Text variant="body" fontWeight={600}>
                            {props.filterByLabel}
                        </Text>
                        <Button
                            size="small"
                            emphasis="high"
                            onClick={() => {
                                props.onChange?.(inputValue);
                                closePopover();
                            }}
                        >
                            {translate('global.filterText.apply')}
                        </Button>
                    </Box>
                    <Box display="flex" flexDirection="row" gap={8} alignItems="center">
                        <Text variant="small" color="foreground.muted">
                            {translate('global.contains')}
                        </Text>
                        <Input
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown(closePopover)}
                        />
                    </Box>
                </Box>
            )}
        </FilterPill>
    );
};
